<template>
  <div class="business-presentation" v-if="content">
    <div class="business-content">
      <img src="https://a.storyblok.com/f/56057/1462x711/0ea7a3f870/160704_city-aventure-business_logo_rvb-01.png" alt="logo city aventure business">
      <h1 v-html="content.text"></h1>
    </div>
    <div class="business-img" :style="{backgroundImage: `url(${content.img})`}"></div>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
    computed: {},
  };
</script>

<style lang="scss">
.business-presentation {
  display: flex;
  height:100vh;
  .business-content {
    flex:2;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin:0 2em;
    img {
      width:55%;
      margin:0 auto;
    }
    h1 {
      font-size:2rem;
      color:$black;
      text-align: center;
    }
  }
  .business-img {
    flex:2;
    background-position: center;
    background-size:cover;
    background-repeat: no-repeat;
    clip-path: polygon(20% 0, 100% 0, 100% 100%, 0% 100%);
    //transform:translateX(-150px);
  }
}

@media screen and (max-width: $desktop) {
  .business-presentation {
    display: flex;

    .business-content {
      position: relative;
      z-index: 3;
      height:100%;
      margin:0;
      background-color:rgba(255,255,255,.8);
      h1 {}
    }
    .business-img {
      width:100%;
      height:100%;
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      clip-path: none;
    }
  }
}


</style>
